import { useParams, useRouteLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { omaElisaForCompaniesMsg, servicesMsg, t } from '../../../../../common/i18n/index.js';
import { BreadCrumbsWithTitle } from '../../../../../components/BreadCrumbsWithTitle/BreadCrumbsWithTitle.js';
import { SubscriptionService } from '../../../../../components/Subscription/SubscriptionService.js';
import { ServiceSubscriptionBasicDetails } from '../../../../../components/SubscriptionDetails/ServiceSubscriptionBasicDetails.js';
import { ServiceSubscriptionLayout } from '../../../../../components/SubscriptionLayout/ServiceSubscriptionLayout.js';
import { isPbxServiceSubscription } from '../../../../../components/SubscriptionLayout/serviceSubscriptionLayoutUtils.js';
import type { SubscriptionId } from '../../../../../common/constants/pathInterfaces.js';
import type { ServiceSubscriptionLoaderResponse } from '../../../../../common/loaders.js';

export const ServicePath = () => {
  const { subscriptionId } = useParams<SubscriptionId>();
  const { companyInfo, hasPendingActions, subscription } = useRouteLoaderData(
    'serviceSub'
  ) as ServiceSubscriptionLoaderResponse;

  if (!isPbxServiceSubscription(subscription)) {
    return (
      <ServiceSubscriptionLayout companyInfo={companyInfo} subscription={subscription}>
        <ServiceSubscriptionBasicDetails
          companyInfo={companyInfo}
          hasPendingActions={hasPendingActions}
          subscription={subscription}
        />
      </ServiceSubscriptionLayout>
    );
  }

  const breadCrumbs = (
    <BreadCrumbsWithTitle
      breadCrumbPaths={[
        { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
        { name: t.MBG9(servicesMsg), path: paths.PS_SERVICES },
        { name: subscriptionId || '' },
      ]}
    />
  );

  return (
    <SubscriptionService
      breadCrumbs={breadCrumbs}
      companyInfo={companyInfo}
      hasPendingActions={hasPendingActions}
      subscription={subscription}
    />
  );
};
